import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { UnknownSshAccesses } from "./accesses/unknown.ts";
import { SshComponents } from "./components.ts";

const sshFilters = {
  destination: {
    keys: ["arn", "full-resource-name", "name"],
    labeler: { arn: "ARN", name: "Instance name" },
  },
  group: { keys: ["name"], labeler: { name: "Group name" } },
  parent: {
    keys: ["id"],
    labeler: {
      id: "GCP project name, AWS account ID, or Azure subscription ID",
    },
  },
  provider: { keys: ["id"] },
  region: {
    keys: ["id"],
    labeler: { id: "AWS region, GCP zone, or Azure region" },
  },
  sudo: { keys: "boolean" },
} as const satisfies AnyFilterSchema;

export type SshFilters = typeof sshFilters;

export const SshRegistration = Registration({
  accesses: UnknownSshAccesses,
  category: "resource",
  components: SshComponents,
  docs: { install: "ssh" },
  filters: sshFilters,
  itemKind: "account",
  label: "Secure Shell (SSH)",
  logoUrl:
    "https://upload.wikimedia.org/wikipedia/commons/b/b3/Terminalicon2.png",
  maturity: "ga",
  requestType: "requestable",
  // TODO: Should map iam_write, but was copied from existing code that omitted this mapping
  useMapping: [],
});

registerIntegration("ssh", SshRegistration);
